import { connect } from 'react-redux';
import FeatureReportExpress from '../../../features/featureReport/reading/FeatureReportExpress';
import { selectors } from '../../../root/reading/root';
import { PERIOD } from '../../../constants/shared/CommonConstants';

const { SUMMARY } = PERIOD;

const mapStateToProps = state => {
    const infoSummary = selectors.getSummaryInfoData(state);
    const assessedStudents = infoSummary.assessedStudentsExpress;
    return {
        performanceTables: selectors.getPerformanceTables(state),
        totalStudentCount: selectors.getTotalNumberOfStudents(state),
        isSummary: selectors.getSelectedPeriod(state) === SUMMARY,
        infoSummary,
        assessedStudents,
        summerPeriodLabel: selectors.getSummerPeriodLabel(state),
    };
};

export default connect(mapStateToProps, {})(FeatureReportExpress);
